import { pagesConfig } from '../router/pagesConfig';

export const GOOGLE_FLOWS = {
  GTG: 'gtg',
  LEGACY: 'legacy',
} as const;

export type GoogleFlow = (typeof GOOGLE_FLOWS)[keyof typeof GOOGLE_FLOWS];

const onboardingPaths = new Set(Object.keys(pagesConfig));

export const getLandingParam = (pathname: string): string => {
  const [pathWithoutEncodedQuery] = pathname.split(/%(?:25)?3f/i);

  return pathWithoutEncodedQuery.split('/').filter(Boolean).join('/').toLowerCase();
};

export const resolveGoogleFlow = (
  pathname: string,
  persistedFlow: GoogleFlow = GOOGLE_FLOWS.LEGACY,
): GoogleFlow => {
  const landingParam = getLandingParam(pathname);

  if (landingParam === GOOGLE_FLOWS.GTG) return GOOGLE_FLOWS.GTG;
  if (onboardingPaths.has(landingParam)) return persistedFlow;

  return GOOGLE_FLOWS.LEGACY;
};
